const PATH_DIALOGS = '/dialogs/';
const PATH_RENDER_CHATS = '/public/v1/render-chats/';

export const getNormalizedPath = () => {
  const path = window.location.pathname;
  const formattedPath = path.startsWith(PATH_DIALOGS)
    ? PATH_DIALOGS
    : path.startsWith(PATH_RENDER_CHATS)
      ? PATH_RENDER_CHATS
      : path;

  return formattedPath;
};
